import React, { useEffect, useState } from 'react';
import { DataContentProps } from '../../newron-core';
import { Instructions } from '../../content/instructions';
import { Loading } from '../../design/loading/Loading';
import { makeTrendsInfo } from './data';
import { TrendsInfo, KpiTrendChart } from '../../design/charts';

function KpiTrends({ data, isLoading, instructions = {}, componentSettings }: DataContentProps) {
  const [dataStamp, setDataStamp] = useState<number>();
  const [info, setInfo] = useState<TrendsInfo>();

  const myInstructions = new Instructions(instructions, componentSettings);

  const grouping = myInstructions.getString('grouping');
  const kpis = myInstructions.getStringList('kpis');

  useEffect(() => {
    if (!data || dataStamp === data.stamp) {
      return;
    }
    const info = makeTrendsInfo(data, grouping, kpis);
    setInfo(info);
    setDataStamp(data.stamp);
  }, [data, grouping, kpis, dataStamp]);

  return (
    <>
      <div className="relative">
        <Loading isActive={isLoading} withIndicator />
        {info && <KpiTrendChart info={info} />}
      </div>
    </>
  );
}

export { KpiTrends };
